// extracted by mini-css-extract-plugin
export var chip = "_d7-0";
export var filterDropdown = "_d7-5";
export var filterItem = "_d7-6";
export var icon = "_d7-1";
export var removeButton = "_d7-3";
export var removeIcon = "_d7-4";
export var separator = "_d7-2";